import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "value", "label", "caption", "disabled", "icon", "checked", "onChange"];
import { ButtonBase, Card as MuiCard, FormControlLabel as MuiFormControlLabel, Radio, Typography } from '@material-ui/core';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Column } from "../columns/Column.js";
import { Columns } from "../columns/Columns.js";
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ClickableCard = /*#__PURE__*/styled(ButtonBase).withConfig({
  displayName: "RadioFieldCard__ClickableCard",
  componentId: "SD__sc-5etge2-0"
})(["display:block;text-align:initial;width:100%;"]);
var Card = /*#__PURE__*/styled(MuiCard).withConfig({
  displayName: "RadioFieldCard__Card",
  componentId: "SD__sc-5etge2-1"
})(["width:100%;opacity:", ";"], props => props.disabled ? 0.5 : 1);
var FormControlLabel = /*#__PURE__*/styled(MuiFormControlLabel).withConfig({
  displayName: "RadioFieldCard__FormControlLabel",
  componentId: "SD__sc-5etge2-2"
})(["width:100%;"]);
var Content = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioFieldCard__Content",
  componentId: "SD__sc-5etge2-3"
})(["padding:16px;width:100%;border-radius:4px;border:1px solid ", ";"], _ref => {
  var {
    active
  } = _ref;
  return active ? ColorDynamic.Blue300 : ColorDynamic.Silver500;
});
var Caption = /*#__PURE__*/styled.div.withConfig({
  displayName: "RadioFieldCard__Caption",
  componentId: "SD__sc-5etge2-4"
})(["padding-left:30px;"]);
export var RadioFieldCard = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var {
      name,
      value,
      label,
      caption,
      disabled,
      icon,
      checked,
      onChange
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_jsx(Card, {
    disabled: disabled,
    children: /*#__PURE__*/_jsx(ClickableCard, _objectSpread(_objectSpread({
      name: name,
      disabled: disabled
    }, props), {}, {
      children: /*#__PURE__*/_jsx(Content, {
        active: checked,
        children: /*#__PURE__*/_jsxs(Columns, {
          space: "small",
          children: [/*#__PURE__*/_jsxs(Column, {
            children: [/*#__PURE__*/_jsx(FormControlLabel, {
              value: value,
              name: name,
              control: /*#__PURE__*/_jsx(Radio, {
                ref: ref,
                checked: checked
              }),
              label: /*#__PURE__*/_jsx(Typography, {
                variant: "h4",
                children: label
              })
            }), /*#__PURE__*/_jsx(Caption, {
              children: /*#__PURE__*/_jsx(Typography, {
                color: "textSecondary",
                variant: "caption",
                children: caption
              })
            })]
          }), /*#__PURE__*/_jsx(Column, {
            width: "content",
            children: icon
          })]
        })
      })
    }))
  }, value);
});
if (process.env.NODE_ENV !== "production") RadioFieldCard.displayName = "RadioFieldCard";